import lazyLoadView from "@/router/lazyLoadView";

const capitalize = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
const routesReducer = routes =>
  routes.reduce((arr, cur) => {
    arr[cur.name] = {
      name: cur.name,
      path: cur.path || `/${cur.name}`,
      hideNavOnMobile: cur.meta && !!cur.meta.hideNavOnMobile,
      verifiedOnly: cur.meta && !!cur.meta.verifiedOnly,
      authRequired: cur.meta && !!cur.meta.authRequired
    };
    return arr;
  }, {});

const routesForRouterReducer = routes =>
  routes.reduce((arr, cur) => {
    if (cur.redirect) {
      arr.push(cur);
      return arr;
    }

    arr.push({
      name: cur.name,
      path: cur.path || `/${cur.name}`,
      components: Object.assign(
        {
          header: () => import("../layout/AppHeader"),
          default: () =>
            lazyLoadView(
              import(
                /* webpackChunkName: "routes" */ `../views/${capitalize(
                  cur.name
                )}.vue`
              )
            ),
          footer: () => import("../layout/AppFooter")
        },
        cur.components
      ),
      meta: cur.meta,
      alias: cur.alias
    });
    return arr;
  }, []);
const routes = [
  {
    name: "home",
    path: "/",
    meta: {
      showHeader: true
    },
    components: {
      banner: () => import("../layout/AppBanner")
    }
  },
  {
    name: "about"
  },
  {
    name: "createWithId",
    path: "/create/:id",
    components: {
      default: () => lazyLoadView(import("../views/Create.vue")),
      footer: false
    },
    meta: {
      hideNavOnMobile: true,
      verifiedOnly: true
    }
  },
  {
    name: "create",
    components: {
      footer: false
    },
    meta: {
      hideNavOnMobile: true,
      verifiedOnly: false
    }
  },
  {
    name: "edit",
    path: "/edit/:id",
    components: {
      default: () => lazyLoadView(import("../views/Create.vue")),
      footer: false
    },
    meta: {
      hideNavOnMobile: true,
      verifiedOnly: true
    }
  },
  {
    name: "editProduction",
    path: "/edit/production/:id",
    components: {
      default: () => lazyLoadView(import("../views/EditProduction.vue")),
      footer: false
    },
    meta: {
      hideNavOnMobile: true,
      verifiedOnly: true
    }
  },
  {
    name: "editNotes",
    path: "/edit/notes/:id",
    components: {
      default: () => lazyLoadView(import("../views/Edit.vue")),
      footer: false
    },
    meta: {
      hideNavOnMobile: true,
      verifiedOnly: true
    }
  },
  {
    name: "editSongInformation",
    path: "/edit-info/:id",
    components: {
      default: () => lazyLoadView(import("../views/EditSongInformation.vue")),
      footer: false
    },
    meta: {
      hideNavOnMobile: true,
      verifiedOnly: true
    }
  },
  {
    name: "library",
    components: {
      footer: false,
      banner: () => import("../layout/AppBanner")
    },
    meta: {
      hideNavOnMobile: false,
      verifiedOnly: true
    }
  },
  {
    name: "s",
    path: "/s/:id",
    components: {
      default: () => lazyLoadView(import("../views/Song.vue")),
      footer: false
    },
    meta: {
      hideNavOnMobile: false,
      verifiedOnly: false
    }
  },
  {
    name: "song",
    path: "/song/:id",
    meta: {
      hideNavOnMobile: false,
      verifiedOnly: false
    }
  },
  {
    name: "style",
    components: {
      default: () => lazyLoadView(import("../views/Styles.vue")),
      footer: false
    },
    meta: {
      hideNavOnMobile: true,
      verifiedOnly: true
    }
  },
  {
    name: "releaseCreate",
    path: "/release/create",
    components: {
      default: () => lazyLoadView(import("../views/NewAlbum.vue")),
      footer: false
    },
    meta: {
      hideNavOnMobile: true,
      verifiedOnly: true
    }
  },

  {
    path: "/releases/create",
    redirect: { name: "releaseCreate" }
  },

  {
    path: "/release",
    redirect: { name: "library" }
  },

  {
    path: "/releases",
    redirect: { name: "library" }
  },

  {
    name: "releaseInfo",
    path: "/release/:id",
    components: {
      default: () => lazyLoadView(import("../views/ReleaseInfo.vue")),
      footer: false
    },
    meta: {
      hideNavOnMobile: true,
      verifiedOnly: true
    }
  },
  {
    name: "editRelease",
    path: "/release/:id/edit",
    components: {
      default: () => lazyLoadView(import("../views/NewAlbum.vue")),
      footer: false
    },
    meta: {
      hideNavOnMobile: true,
      verifiedOnly: true
    },
    alias: [`/release/:id/edit/songs`, `/release/:id/edit/submit`]
  },
  {
    name: "earn",
    meta: {
      hideNavOnMobile: false,
      verifiedOnly: true
    }
  },
  {
    name: "terms"
  },
  {
    name: "tag",
    path: "/tag/:id",
    components: {
      banner: () => import("../layout/AppBanner")
    }
  },
  {
    name: "eula",
    components: {
      default: () => lazyLoadView(import("../views/EULA.vue"))
    }
  },
  {
    name: "faqs",
    components: {
      default: () => lazyLoadView(import("../views/FAQs.vue"))
    }
  },
  {
    name: "privacy"
  },
  {
    name: "signIn",
    path: "/sign-in",
    components: {
      default: () => lazyLoadView(import("../views/Login.vue"))
    }
  },
  {
    name: "signUp",
    path: "/sign-up",
    components: {
      default: () => lazyLoadView(import("../views/Login.vue"))
    }
  },
  {
    name: "admin",
    meta: {
      hideNavOnMobile: false,
      verifiedOnly: true
    }
  },
  {
    name: "verify",
    meta: {
      authRequired: true
    }
  },
  {
    name: "addVocals",
    path: "/add-vocals/:id",
    components: {
      default: () => lazyLoadView(import("../views/AddVocals.vue")),
      footer: false
    },
    meta: {
      hideNavOnMobile: true,
      verifiedOnly: true
    }
  },
  {
    name: "rewriteSong",
    path: "/rewrite/:id",
    components: {
      default: () => lazyLoadView(import("../views/RewriteSong.vue")),
      footer: false
    },
    meta: {
      hideNavOnMobile: true,
      verifiedOnly: true
    }
  },

  {
    name: "_loader"
  },

  {
    name: "_timeout"
  },

  {
    path: "*",
    name: "pageNotFound"
  }
];

export const ROUTES = routesReducer(routes);

export const ROUTES_FOR_ROUTER = routesForRouterReducer(routes);
